import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSidenavContent]',
  standalone: false,
})
export class SidenavContent {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
